import route from 'ziggyRoute';
import { Ziggy } from './ziggy';

const r = (name, params, absolute, config = Ziggy) => route(name, params, absolute, config);

export default r;
